import { createElement, Fragment } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { AlignmentControl, BlockControls, Warning, useBlockProps, store as blockEditorStore } from '@wordpress/block-editor';
import { useEntityProp, store as coreStore } from '@wordpress/core-data';
import { __, sprintf } from '@wordpress/i18n';
import { useSelect } from '@wordpress/data';
/**
 * Internal dependencies
 */

import CommentsForm from './form';
export default function PostCommentsFormEdit(_ref) {
  let {
    attributes,
    context,
    setAttributes
  } = _ref;
  const {
    textAlign
  } = attributes;
  const {
    postId,
    postType
  } = context;
  const [commentStatus] = useEntityProp('postType', postType, 'comment_status', postId);
  const blockProps = useBlockProps({
    className: classnames({
      [`has-text-align-${textAlign}`]: textAlign
    })
  });
  const isSiteEditor = postType === undefined || postId === undefined;
  const {
    defaultCommentStatus
  } = useSelect(select => select(blockEditorStore).getSettings().__experimentalDiscussionSettings);
  const postTypeSupportsComments = useSelect(select => {
    var _select$getPostType;

    return postType ? !!((_select$getPostType = select(coreStore).getPostType(postType)) !== null && _select$getPostType !== void 0 && _select$getPostType.supports.comments) : false;
  });
  let warning = false;
  let showPlaceholder = true;

  if (!isSiteEditor && 'open' !== commentStatus) {
    if ('closed' === commentStatus) {
      warning = sprintf(
      /* translators: 1: Post type (i.e. "post", "page") */
      __('Post Comments Form block: Comments on this %s are not allowed.'), postType);
      showPlaceholder = false;
    } else if (!postTypeSupportsComments) {
      warning = sprintf(
      /* translators: 1: Post type (i.e. "post", "page") */
      __('Post Comments Form block: Comments for this post type (%s) are not enabled.'), postType);
      showPlaceholder = false;
    } else if ('open' !== defaultCommentStatus) {
      warning = __('Post Comments Form block: Comments are not enabled.');
      showPlaceholder = false;
    }
  }

  return createElement(Fragment, null, createElement(BlockControls, {
    group: "block"
  }, createElement(AlignmentControl, {
    value: textAlign,
    onChange: nextAlign => {
      setAttributes({
        textAlign: nextAlign
      });
    }
  })), createElement("div", blockProps, warning && createElement(Warning, null, warning), showPlaceholder ? createElement(CommentsForm, null) : null));
}
//# sourceMappingURL=edit.js.map